// Picks local (IndexedDB, legacy db.js) or remote (Supabase) at runtime.
// Sets `window.IFI.studio.db` so legacy view IIFEs see the chosen adapter.
// The Window.IFI global is declared in main.ts (single source of truth).

import type { RemoteDb } from './remote';

export function bindDbAdapter(remote: RemoteDb, mode: 'local' | 'supabase'): void {
  const w = window as Window & { IFI?: { studio: Record<string, unknown> } };
  w.IFI = w.IFI ?? { studio: {} };
  w.IFI.studio = w.IFI.studio ?? {};
  const studio = w.IFI.studio;

  // legacy IndexedDB module sets studio.db when it loads
  const localDb = studio.db;
  studio.dbLocal = localDb;
  studio.dbRemote = remote;

  if (mode === 'supabase') {
    studio.db = remote;
    studio.STORAGE_MODE = 'supabase';
    setBadge('ok', 'Cloudflare D1');
    console.info('[db-adapter] mode=worker (Cloudflare D1)');
  } else {
    studio.db = localDb;
    studio.STORAGE_MODE = 'local';
    setBadge('warn', 'Local IndexedDB');
    console.info('[db-adapter] mode=local');
  }
}

function setBadge(state: 'ok' | 'warn' | 'err', text: string): void {
  const apply = () => {
    const el = document.getElementById('storageModeBadge');
    if (!el) return;
    el.textContent = text;
    el.classList.remove('badge--ok', 'badge--warn', 'badge--err');
    el.classList.add(`badge--${state}`);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
}
